/** Returns an inline SVG string for a seat icon filled with the given hex colour (without #). */
export function seatIconSvg(colorHex: string, size: number = 24): string {
  const color = colorHex.startsWith('#') ? colorHex : `#${colorHex}`;
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}">
    <circle cx="12" cy="12" r="9" fill="${color}"/>
  </svg>`;
}

/** Returns an inline SVG string for a customer-selected seat: black circle with a green checkmark. */
export function selectedSeatIconSvg(size: number = 24): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}">
    <circle cx="12" cy="12" r="9" fill="#000000"/>
    <path transform="translate(12,12) scale(0.6) translate(-12,-12)" d="M18.4492 5.55664C18.6433 5.42848 18.9073 5.45023 19.0781 5.62109L20.5029 7.0459C20.5967 7.13962 20.6494 7.26688 20.6494 7.39941C20.6494 7.53202 20.5967 7.65916 20.5029 7.75293L9.90332 18.3535C9.70815 18.5486 9.39154 18.5485 9.19629 18.3535L3.49609 12.6533C3.30086 12.4581 3.30093 12.1416 3.49609 11.9463L4.9209 10.5215L4.99707 10.459C5.07862 10.4045 5.17492 10.375 5.27441 10.375C5.40702 10.375 5.53416 10.4277 5.62793 10.5215L9.54883 14.4424L18.3711 5.62109L18.4492 5.55664Z" fill="#8ADA99" stroke="#8ADA99" stroke-linejoin="round"/>
  </svg>`;
}

/** Converts an SVG string to an HTMLImageElement at the specified dimensions. */
export function svgToImage(svgString: string, width: number, height: number): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image(width, height);
    const b64 = btoa(unescape(encodeURIComponent(svgString)));
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = `data:image/svg+xml;base64,${b64}`;
  });
}
